export const responsiveVanillaSelector = '#article-body a, #gallery-body a, .article-body a';
export const progressiveVanillaSelector = '.article__body a, #article-body a, .article-body a';
export const forumSelector = '.p-body-pageContent a';
